import {
  SR_RFQ_LIST,
  SR_RFQ_LIST_SUCCESS,
  INPUT_SR_CHANGEVALUE,
  SELECT_SR_CHANGEVALUE,
  RFQ_NO_SELECT_SR_CHANGEVALUE,
  SR_RFQ_ROW_DATA,
  SR_RFQ_ROW_DATA_SUCCESS,
  SR_QSR_ITEM_REMOVE,
  SR_Q_VENDORS_LIST,
  SR_Q_VENDORS_LIST_SUCCESS,
  SR_ITEM_QTY_SR_CHANGEVALUE,
  SR_ITEM_UNIT_SR_CHANGEVALUE,
  SR_ITEM_PRICE_SR_CHANGEVALUE,
  SR_ITEM_BASEPRICE_SR_CHANGEVALUE,
  SR_ITEM_TAXTYPE_SR_CHANGEVALUE,
  SR_ITEM_TAX_SR_CHANGEVALUE,
  SR_ITEM_GROSS_VAL_SR_CHANGEVALUE,
  SR_QUOTATION_ADD,
  SR_QUOTATION_LIST,
  SR_QUOTATION_LIST_SUCCESS,
  TOGGLE_SR_ITEM_MENU,
  SET_PARAMS,
  FILTER_INPUT_SR_CHANGEVALUE,
  FILTER_SELECT_SR_CHANGEVALUE,
  Q_SR_MODEL_LIST_OPEN,
  Q_SR_MODEL_LIST_CLOSE,
  SR_QOUTATION_DATA,
  SR_QOUTATION_DATA_SUCCESS,
  SR_LIST_LAYOUT,
  SRQ_FILTERS_SHOW_RIGHT_SIDEBAR,
  SR_FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  RFQ_SR_FILTERS_LIST,
  RFQ_SR_FILTERS_LIST_SUCCESS,
  SR_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
  SR_MR_CODE_DETAILS,
  SR_MR_CODE_DETAILS_SUCCESS,
  SR_PI_CODE_DETAILS,
  SR_PI_CODE_DETAILS_SUCCESS,
  MR_SR_ITEM_IMAGES,
  MR_SR_ITEM_IMAGES_SUCCESS,
  RFQ_MR_SR_ITEM_IMAGES_SR_MODEL_CLOSE,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  rfqList: [],
  rfqFilterList: [],
  QRowData: {},
  QRfQNo: {},
  RFQrowdata: [],
  qitems: [],
  QVendorsList: [],
  QRowList: [],
  QRowListCount: 0,
  Sortvar: {
    code: "SR_QUOTATION NO",
    createdon: "CREATED ON",
  },
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  layout: "list",
  showFilterRightSidebar: false,
  RFQMRItemImages: [],
  RFQMRItemImagesModel: false,
};

const SRQuotation = (state = initialState, action) => {
  switch (action.type) {
    case SR_RFQ_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_RFQ_LIST_SUCCESS:
      state = {
        ...state,
        rfqList: action.payload,
        loading: false,
      };
      break;

    case SR_Q_VENDORS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_Q_VENDORS_LIST_SUCCESS:
      state = {
        ...state,
        QVendorsList: action.payload,
        loading: false,
      };
      break;
    case INPUT_SR_CHANGEVALUE:
      state = {
        ...state,
        QRowData: {
          ...state.QRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case RFQ_NO_SELECT_SR_CHANGEVALUE:
      state = {
        ...state,
        QRfQNo: {
          ...state.QRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SELECT_SR_CHANGEVALUE:
      state = {
        ...state,
        QRowData: {
          ...state.QRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SR_RFQ_ROW_DATA:
      state = {
        ...state,
        loading: true,
        QRowData: {},
        qitems: [],
      };
      break;
    case SR_RFQ_ROW_DATA_SUCCESS:
      console.log("ACtio.........",action.payload)
      var qItems = [];
      action.payload.srfqitems.map((i) => {
        var qitem = {
          id: i.id,
          rfqitem: i.id,
          product: i.product,
          originalqty: i.qty,
          qty: i.qty,
          unit: i.unit,
          unit_id: i.unit.id,
          make: i.make,
          description: i.description,
          discount: 0,
          discountpercent: 0,
          // qitems.taxtype = 1;
          // qitems.tax = i.tax;
        };
        qItems.push(qitem);
        return i;
      });
      state = {
        ...state,
        RFQrowdata: action.payload,
        qitems: qItems,
        loading: false,
      };
      break;
    case SR_QSR_ITEM_REMOVE:
      var deleteQItems = state.qitems.map((item) => {
        if (action.payload.id === item.id) {
          item.dodelete = true;
        }
        return item;
      });
      // var filterQItems = state.qitems.filter((item) => {
      //   if (action.payload.id !== item.id) {
      //     return true;
      //   }
      //   return false;
      // });
      state = {
        ...state,
        qitems: deleteQItems,
        loading: false,
      };
      break;
    case SR_ITEM_QTY_SR_CHANGEVALUE:
      var qitems1 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.qty = action.payload.value;
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems1,
      };
      break;
    case SR_ITEM_UNIT_SR_CHANGEVALUE:
      var qitems2 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.unit = {
            id: action.payload.value,
            name: action.payload.label,
          };
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems2,
      };
      break;

    case SR_ITEM_PRICE_SR_CHANGEVALUE:
      var qitems3 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.price = action.payload.value;
          i.discount = action.payload.discount;
          i.discountpercent = action.payload.discountpercent;
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems3,
      };
      break;
    case SR_ITEM_BASEPRICE_SR_CHANGEVALUE:
      var qitems8 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.baseprice = action.payload.value;
          i.price = action.payload.price;
          i.discount = action.payload.discount;
          // i.discountpercent = action.payload.discountpercent;
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems8,
      };
      break;
    case SR_ITEM_DISC_PERCENT_SR_CHANGEVALUE:
      var qitems7 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.discountpercent = action.payload.value;
          i.price = action.payload.price;
          i.discount = action.payload.discount;
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems7,
      };
      break;
    case SR_ITEM_TAXTYPE_SR_CHANGEVALUE:
      var qitems4 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.taxtype = {
            id: action.payload.value,
            name: action.payload.label,
          };
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems4,
      };
      break;

    case SR_ITEM_TAX_SR_CHANGEVALUE:
      var qitems5 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.tax = {
            id: action.payload.id,
            tax: action.payload.tax,
            name: action.payload.name,
          };
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems5,
      };
      break;
    case SR_ITEM_GROSS_VAL_SR_CHANGEVALUE:
      var qitems6 = state.qitems.map((i) => {
        if (i.id === action.payload.item.id) {
          i.gross = parseFloat(action.payload.net);
          i.taxamt = parseFloat(action.payload.taxamt);
        }
        return i;
      });
      state = {
        ...state,
        qitems: qitems6,
      };
      break;
    case SR_QUOTATION_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_QUOTATION_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_QUOTATION_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        QRowList: action.payload.results,
        QRowListCount: action.payload.count,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
      };
      break;
    case TOGGLE_SR_ITEM_MENU:
      var QRowList = state.QRowList?.map((i) => {
        if (i.id === action.payload) {
          i.actionMenu = !i.actionMenu;
        } else {
          i.actionMenu = false;
        }
        return i;
      });

      state = {
        ...state,
        QRowList: QRowList,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case FILTER_INPUT_SR_CHANGEVALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case FILTER_SELECT_SR_CHANGEVALUE:
      state = {
        ...state,
        filterdata: {
          ...state.filterdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case Q_SR_MODEL_LIST_OPEN:
      state = {
        ...state,
        QlistModel: true,
      };
      break;
    case Q_SR_MODEL_LIST_CLOSE:
      state = {
        ...state,
        QlistModel: false,
      };
      break;
    case SR_QOUTATION_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_QOUTATION_DATA_SUCCESS:
      state = {
        ...state,
        QRowData: action.payload.response,
        qitems: action.payload.response.sqitems,
        loading: false,
      };
      break;
    case SR_LIST_LAYOUT:
      state = {
        ...state,
        layout: action.payload,
        loading: false,
      };
      break;
    case SRQ_FILTERS_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        showFilterRightSidebar: !state.showFilterRightSidebar,
      };
      break;
    case SR_FILTERS_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,

        showFilterRightSidebar: false,
      };
      break;
    case CLEAR_FILTER:
      state = {
        ...state,
        filterdata: {},
      };
      break;
    case RFQ_SR_FILTERS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_SR_FILTERS_LIST_SUCCESS:
      state = {
        ...state,
        rfqFilterList: action.payload,
        loading: false,
      };
      break;
    case SR_MR_CODE_DETAILS:
      state = {
        ...state,
        loading: true,
        QItemId: action.payload.ItemId,
      };
      break;

    case SR_MR_CODE_DETAILS_SUCCESS:
      var qitems = state.QRowData.sqitems.map((item, i) => {
        if (item.id === state.QItemId) {
          item.mrdata = action.payload;
        }
        return item;
      });
      state = {
        ...state,
        QRowData: { ...state.QRowData, qitems: qitems },
        loading: false,
      };
      break;
    case SR_PI_CODE_DETAILS:
      state = {
        ...state,
        loading: true,
        QItemId: action.payload.ItemId,
      };
      break;

    case SR_PI_CODE_DETAILS_SUCCESS:
      var qitems_1 = state.QRowData.sqitems.map((item, i) => {
        if (item.id === state.QItemId) {
          item.pidata = action.payload;
        }
        return item;
      });
      state = {
        ...state,
        QRowData: { ...state.QRowData, qitems: qitems_1 },
        loading: false,
      };
      break;
    case MR_SR_ITEM_IMAGES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MR_SR_ITEM_IMAGES_SUCCESS:
      state = {
        ...state,
        RFQMRItemImages: action.payload,
        loading: false,
        RFQMRItemImagesModel: true,
      };
      break;
    case RFQ_MR_SR_ITEM_IMAGES_SR_MODEL_CLOSE:
      state = {
        ...state,
        RFQMRItemImagesModel: false,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};
export default SRQuotation;
